import * as React from 'react';

export const Grid = (props: any) => {
  return <div {...props} />;
};
